import { render, staticRenderFns } from "./ChatMessageVideoSlot.vue?vue&type=template&id=81651e98&scoped=true&"
import script from "./ChatMessageVideoSlot.vue?vue&type=script&lang=js&"
export * from "./ChatMessageVideoSlot.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageVideoSlot.vue?vue&type=style&index=0&id=81651e98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81651e98",
  null
  
)

export default component.exports